export default "__VITE_ASSET__DsvbFTv7__"